<div class="date-mng-block">
    <div class="mat-elevation-z3 date-mng-block-button">
        <mat-icon
                class="mat-elevation-z3 date-mng-block-button-icon" data-action="changeMonth" (click)="changeMonth(-1)">
            arrow_back_ios_new
        </mat-icon>
    </div>
    <p class="mat-elevation-z3 date-mng-block-button-label">
        {{ 'WIDGETS.CALENDAR_TASKS.MONTH.' + periodChart.month | translate }} {{ periodChart.year }}
    </p>
    <div class="mat-elevation-z3 date-mng-block-button">
        <mat-icon class="mat-elevation-z3 date-mng-block-button-icon" data-action="changeMonth"
                  (click)="changeMonth(1)">
            arrow_forward_ios
        </mat-icon>
    </div>
</div>
<div
        id="calendarChart"
        class="calendar-chart">
</div>